export default __webpack_public_path__ + "static/media/lease-guide-chart-2.cb1eb947.svg";